import React from "react";
import graduation_cap from "./images/icons/graduation_cap.png";
import { Image } from "react-bootstrap";
import {
  sectionHeadingStyle,
  sectionContainerStyle,
  headingContainerStyle,
  bioStyle,
} from "./components/styles";
const educationData = [
  {
    unit: "FIT4002 - Software Engineering Industry Experience",
    numberGrade: 92,
    textGrade: "HD",
  },
  {
    unit: "FIT3178 - iOS App Development",
    numberGrade: 98,
    textGrade: "HD",
  },
  {
    unit: "FIT1051 - Programming Fundamentals in Java",
    numberGrade: 92,
    textGrade: "HD",
  },
  {
    unit: "FIT3146 - Maker Lab",
    numberGrade: 89,
    textGrade: "HD",
  },
  {
    unit: "FIT3171 - Databases",
    numberGrade: 84,
    textGrade: "HD",
  },
  {
    unit: "FIT3170 - Software Engineering Practice",
    numberGrade: 93,
    textGrade: "HD",
  },
  {
    unit: "FIT2081 - Mobile Application Development",
    numberGrade: 85,
    textGrade: "HD",
  },
  {
    unit: "FIT4165 - Computer Networks",
    numberGrade: 87,
    textGrade: "HD",
  },
  {
    unit: "FIT4003 - Software Engineering Research Project",
    numberGrade: 83,
    textGrade: "HD",
  },
  {
    unit: "FIT5145 - Introduction to Data Science",
    numberGrade: 85,
    textGrade: "HD",
  },
  {
    unit: "FIT2004 - Algorithms and Data Structures",
    numberGrade: 75,
    textGrade: "D",
  },
  {
    unit: "FIT3077 - Software Engineering: Architecture and Design",
    numberGrade: 81,
    textGrade: "HD",
  },
  {
    unit: "FIT3159 - Computer Architecture",
    numberGrade: 75,
    textGrade: "D",
  },
  {
    unit: "MAT1830 - Discrete Mathematics for Computer Science",
    numberGrade: 87,
    textGrade: "HD",
  },
  {
    unit: "FIT2100 - Operating Systems",
    numberGrade: 74,
    textGrade: "D",
  },
  {
    unit: "FIT3143 - Parallel Computing",
    numberGrade: 80,
    textGrade: "HD",
  },
  {
    unit: "FIT3179 - Data Visualisation",
    numberGrade: 83,
    textGrade: "HD",
  },
];

const Education = () => {
  return (
    <div style={sectionContainerStyle}>
      <div style={headingContainerStyle}>
        <h2 style={sectionHeadingStyle}>Education</h2>
        <Image
          src={graduation_cap}
          alt=""
          className="section-icon"
        />
      </div>
      <p style={bioStyle}>
        I graduated from Monash University in 2022 with a Software Engineering
        (Honours) degree. During my time there, I focused on web and app
        development, gaining hands-on experience through projects that sharpened
        my skills in dynamic web applications and mobile apps.
      </p>

      <div style={scrollableContainerStyle}>
        <div style={scrollableContentStyle}>
          {educationData.map((item, index) => (
            <div key={index} style={containerStyle}>
              <div style={unitCodeStyle}>
                <span>{item.unit.split(" ")[0]}</span>
              </div>
              <div style={unitNameStyle}>
                <span>{item.unit.split("-").slice(1).join("-")}</span>
              </div>
              <div style={marksStyle}>
                <span>{item.numberGrade}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const scrollableContainerStyle = {
  maxHeight: "58vh",
  overflowY: "auto",
  paddingRight: "10px",
  marginRight: "-10px",
  MsOverflowStyle: "none", // Hide scrollbar in Internet Explorer and Edge
  scrollbarWidth: "none", // Hide scrollbar in Firefox
};

const containerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "10px",
  padding: "12px 16px",
  background: "rgba(255, 255, 255, 0.76)",
  border: "1px solid rgba(24, 23, 22, 0.1)",
  borderRadius: "14px",
  boxShadow: "0 10px 24px rgba(40, 36, 30, 0.06)",
};

const scrollableContentStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "0px",
};

const unitCodeStyle = {
  flex: "0 0 22%",
  textAlign: "left",
  fontWeight: 800,
  color: "#181716",
};

const unitNameStyle = {
  flex: "1",
  textAlign: "left",
};

const marksStyle = {
  flex: "0 0 15%",
  textAlign: "right",
  fontWeight: 900,
  color: "#0f766e",
};

export default Education;
